import { render, staticRenderFns } from "./ModalPlanningNew.vue?vue&type=template&id=3c8c64c6&scoped=true&"
import script from "./ModalPlanningNew.vue?vue&type=script&lang=ts&"
export * from "./ModalPlanningNew.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPlanningNew.vue?vue&type=style&index=0&id=3c8c64c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8c64c6",
  null
  
)

export default component.exports